import * as React from "react";
import { cn } from "../utils/utils";
import { MdErrorOutline } from "react-icons/md";

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(
      // "relative w-full rounded-lg border border-red-500 p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
      // "border-destructive/50 text-destructive dark:border-destructive [&>svg]:text-destructive",

      "relative w-full rounded-lg border border-red-500 pt-3 pb-4 px-4",
      "border-destructive/50 text-destructive dark:border-destructive",
      className
    )}
    {...props}
  />
));
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn(" text-lg text-red-500 font-semibold", className)}
    {...props}
  />
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";

type ErrorType = string | { message: string } | unknown;
const getErrorMessage = (error: ErrorType): string => {
  if (typeof error === "string") {
    return error;
  }

  if (error && typeof error === "object") {
    if ("message" in error) {
      return error.message as string;
    }

    // Handle cases where the error might be JSON stringifiable
    try {
      return JSON.stringify(error);
    } catch {
      return "An unexpected error occurred";
    }
  }

  return "An unexpected error occurred";
};

const AlertError = ({ errorMessage }: { errorMessage: ErrorType }) => (
  <Alert className="flex flex-col bg-red-500/20">
    <div className="flex items-center flex-row">
      <MdErrorOutline className="h-4 w-4 text-red-500 mr-2 " />
      <AlertTitle>Error</AlertTitle>
    </div>
    <div>
      <AlertDescription>{getErrorMessage(errorMessage)}</AlertDescription>
    </div>
  </Alert>
);

export { AlertError };
